import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import Map from '../MapLeaflet';
import {BASE_URL_JAVAZ_API} from 'constants/ActionTypes';
import InputVirtual from 'components/InputVirtual'
import wellknown from 'wellknown';

const apiUrlHeader = BASE_URL_JAVAZ_API;
const apiUrl = apiUrlHeader+"/geofence";
const masterTitleLower = "geofence";
const masterTitleCapital = "Geofence";
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
      flex: {
        flex: 1,
    },
    button: {
      margin: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
      },
  });

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };

function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
  
    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
  }

const MySnackbarContentWrapper = withStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
    },
    warning: {
      backgroundColor: amber[700],
    },
    iconSnack: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }))(MySnackbarContent);

class DialogForm extends React.Component {

    callbackCompany = ({id}) => {
        this.setState({companyIdForm: id})
    };

    async componentDidMount() {
        this.props.showDialog(this.showDialog);
        // console.log('showdialog1', this.showDialog);
        // console.log('showdialog2', this.props.showDialog);
        // if (navigator.geolocation) {
        //   navigator.geolocation.getCurrentPosition(this.showPosition);
        // } else {
        //   alert("Geolocation is not supported by this browser.");
        // }
    };

    componentDidUpdate() {
      if (this.state.isParentClick) {
        if (this.props.idData === 0) {
          localStorage.removeItem('drawnPolygon');
          this.setState({
            openDialog: true,
            action: "tambah",
            companyIdForm: companyIdGlobal,
            geofenceCodeForm: "",
            geofenceNameForm: "",
            addressForm: "",
            remarkForm: "",
            statusForm: true,
            drawLocation: "",
            drawLocationArr: [],
            openMap: false,
            drawnPolygon: this.props.drawnPolygon || {
              type: 'Feature',
              features: [],
            },
            centroidLat: this.props.centroidLat || 0,
            centroidLng: this.props.centroidLng || 0,
          });
        } else {
          this.setState({ action: "ubah" }, () => {
            this.handleClickOpenEdit(this.props.idData);
          });
        }
        this.setState({ isParentClick: false });
      }
    }    

    constructor(props, context) {
        super(props, context);
        this.state = {
            openDialog: false,
            openMap: false,
            isParentClick: false,
            action: "tambah",

            //snackbar state
            openSnackSuccess: false,
            openSnackErr: false,
            messageSnackBar:"",

            idData:0,

            //FORM================================================
            companyIdForm:companyIdGlobal,
            geofenceCodeForm: "",
            geofenceNameForm: "",
            addressForm: "",
            remarkForm: "",
            statusForm: true,
            drawLocation: "",
            drawLocationArr: [],
            openMap: false,
            loading: false,
            centroidLat: 0,
            centroidLng: 0,
        };

        this.showDialog = this.showDialog.bind(this);
        // console.log('showdialog3', this.showDialog);
    };

    showDialog() {
        
        this.setState({ isParentClick : true });
    };

    // logic new ================================================================================
    handleClose = async(param) => {
      // console.log('handleClose param', param);
        if(param === 'batal'){
            
            this.setState({ idData:0, openDialog: false });
            this.props.closeDialog(); 
        } else if (param === 'tambah') {
            this.setState({idData:0, loading: true })
        
            const data = {
                "name" : this.state.geofenceNameForm,
                "company" : parseInt(this.state.companyIdForm),
                "geofence_code": this.state.geofenceCodeForm,
                "address": this.state.addressForm,
                "remark": this.state.remarkForm,
                "status": this.state.statusForm,
                "geom": this.state.drawLocation,
                "latitude": this.state.centroidLat,
                "longitude": this.state.centroidLng
            }

            let obj = JSON.stringify(data);
            
            const result = await axios.post(apiUrl+'/new', obj, config)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.code === 201){
                NotificationManager.success("Success insert "+masterTitleLower+" data", 'Success message') 
                this.setState({ openDialog: false, loading: false });
                this.props.closeDialog(result.data); 
            }else{
                this.setState({loading: false})
                NotificationManager.error("Failed insert "+masterTitleLower+" data : "+result.data.message, 'Error message')
            }     
        } else if (param === 'ubah') {
            const {idData} = this.state
            this.setState({loading: true})
            const data = {
                "name" : this.state.geofenceNameForm,
                "company" : parseInt(this.state.companyIdForm),
                "geofence_code": this.state.geofenceCodeForm,
                "address": this.state.addressForm,
                "remark": this.state.remarkForm,
                "status": true,
                "geom": this.state.drawLocation,
                "latitude": this.state.centroidLat,
                "longitude": this.state.centroidLng
            }
            let obj = JSON.stringify(data);    
            const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, config)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.code === 200){
                
                NotificationManager.success("Success update "+masterTitleLower+" data", 'Success message') 
                
                this.setState({ openDialog: false, loading: false });
                this.props.closeDialog(result.data);  
            }else{
                this.setState({ loading: false })
                NotificationManager.error("Failed update "+masterTitleLower+" data : "+result.data.message, 'Error message')
                
            }
        }
        
    };


    //logic open edit ===========================================================================
    handleClickOpenEdit = async(id) => {
        this.setState({openDialog: true, idData:id})
        const drawnPolygonExist = localStorage.getItem('drawnPolygon');
        const result = await axios.get(`${apiUrl}/${id}`, config)
                            .then(res => res)
                            .catch((error) => error.response )
                          
        if(result.data.code === 200){
         
            this.setState({
                companyIdForm:result.data.data.company,
                geofenceCodeForm: result.data.data.geofence_code,
                geofenceNameForm:result.data.data.name,
                addressForm: result.data.data.Address,
                remarkForm: result.data.data.remark,
                statusForm: result.data.data.status,
                drawLocation: result.data.data.geom,
                centroidLat: result.data.data.latitude,
                centroidLng: result.data.data.longitude,
                loading: false
            })   

            const leafletGeoJSON = wellknown.parse(result.data.data.geom);
              if (drawnPolygonExist) {
                localStorage.removeItem('drawnPolygon');
                localStorage.setItem('drawnPolygon', JSON.stringify(leafletGeoJSON)); 
              }
            localStorage.setItem('drawnPolygon', JSON.stringify(leafletGeoJSON)); 
        }
    };

    // openMap = () => {
    //     this.setState({openMap: true});
    // }

    openMap = () => {
      // Get the existing drawnPolygon value from localStorage
      const existingDrawnPolygon = localStorage.getItem('drawnPolygon');

      // Check if the existing value is undefined
      if (existingDrawnPolygon === 'undefined' || existingDrawnPolygon === undefined) {
        // Remove the localStorage item
        localStorage.removeItem('drawnPolygon');

        // console.log('drawnPolygon removed from localStorage');
      } else {
        // The value is not undefined, you can handle it as needed
        // console.log('drawnPolygon exists in localStorage:', existingDrawnPolygon);
        // localStorage.setItem('existingDrawnPolygon', JSON.stringify(existingDrawnPolygon));
      }

      // const {drawnPolygon} = this.state;
      // if (drawnPolygon) {
      //   this.setState({ drawnPolygon });
      // }
      // console.log('drawnPolygon123', drawnPolygon);
      this.setState({ openMap: true });
    }

    closeMap = (action, geojson, centroidLat, centroidLng) => {
      // console.log('state closeMap', this.state);
      // console.log('props closeMap', this.props);
      if (this.props.idData === 0 && action !== '') {
        // console.log('closeMap action1', action);
        if (action === 'batal') {
          localStorage.removeItem('drawnPolygon');
          this.setState({ drawLocation: '', openMap: false });
        } else if (action === 'save') {
          // console.log('closeMap action add', action);
          // console.log('closeMap geojson add', geojson);
          // console.log('closeMap centroidLat add', centroidLat);
          // console.log('closeMap centroidLng add', centroidLng);
          if (geojson == '') {
            localStorage.removeItem('drawnPolygon');
            // NotificationManager.error("Failed to save the polygon, please draw the polygon first. If you already draw the polygon please edit the polygon first and then try to save again", 'Error message');
          } else {
            // this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
          }
          this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
        }  
      } else if (this.props.idData !== 0) {
        if (action === 'batal') {
          this.setState({ openMap: false });
        } else if (action === 'save') {
          // console.log('closeMap action edit', action);
          // console.log('closeMap geojson edit', geojson);
          // console.log('closeMap centroidLat edit', centroidLat);
          // console.log('closeMap centroidLng edit', centroidLng);
          if (geojson == '') {
            localStorage.removeItem('drawnPolygon');
            // NotificationManager.error("Failed to save the polygon, please edit the polygon first.", 'Error message');
          } else {
            // this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
          }
          this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
        }  
      }
      
      // console.log('closeMap action out', action);
      // console.log('closeMap geojson out', geojson);
      // this.setState({ openMap: false });
    }

    setCoordsStr = (coordsStr, coordsArr) => {
        this.setState({drawLocation: coordsStr, drawLocationArr: coordsArr});
    } 

    drawnPolygon = (polygon) => {
      this.setState({drawnPolygon: polygon});
      localStorage.removeItem('drawnPolygon');
      localStorage.setItem('drawnPolygon', polygon);
      // console.log('drawnPolygon123', polygon);
    }

    setCoordinates = (wktString, centroidLat, centroidLng) => {
        // console.log('setCoordinates wktString', wktString);
        // console.log('setCoordinates centroidLat', centroidLat);
        // console.log('setCoordinates centroidLng', centroidLng);
    }  

    handleDrawnPolygonChange = (drawnPolygon) => {
      this.setState({ drawnPolygon });
    };
    
    render() {
        const {classes} = this.props
        const {loading} = this.state
        return (
            <div>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackSuccess}
                  autoHideDuration={4000}
                  onClose={() => this.setState({ openSnackSuccess: false })}
                >
                  <MySnackbarContentWrapper
                    onClose={() => this.setState({ openSnackSuccess: false })}
                    variant="success"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackErr}
                  autoHideDuration={4000}
                  onClose={() => this.setState({ openSnackErr: false })}
                >
                  <MySnackbarContentWrapper
                  onClose={() => this.setState({ openSnackErr: false })}
                    variant="error"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>

                <NotificationContainer/>
                    
                <Dialog
                fullScreen
                open={this.state.openDialog}
                onClose={() => this.handleClose('batal')}
                TransitionComponent={Transition}
                >
                <AppBar className="sticky-container">
                    <Toolbar>
                    <Typography variant="h6" color="inherit" className={classes.flex}>
                        {masterTitleCapital}
                    </Typography>
                    <Button 
                      variant="raised" 
                      disabled={loading}
                      style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
                      className="bg-white text-black" 
                      onClick={() => { if(!loading) this.handleClose('batal')}}
                    >
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button 
                      variant="raised" 
                      color="primary" 
                      disabled={loading} 
                      style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
                      onClick={() => { if(!loading) this.handleClose(this.state.action) }}
                    >		 
						{loading ? (
							<CircularProgress
								className="text-white"
								size={24}
							/>						  
						) : this.state.action}
                    </Button>
                    </Toolbar>
                </AppBar>
                <br/>
                <br/>
                <div className="app-wrapper">
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            <Grid item xs={12}>
                                <InputVirtual 
                                    label="Perusahaan"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={apiUrlHeader+"/company/search"}
                                    getData={this.callbackCompany}
                                    setData={[{name:"id",value:this.state.companyIdForm.toString(),"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormCompany"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Kode Geofence"
                                  value={this.state.geofenceCodeForm}
                                  fullWidth
                                  onChange={(e) => this.setState({geofenceCodeForm: e.target.value})}
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Geofence"
                                  value={this.state.geofenceNameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({geofenceNameForm: e.target.value})}
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Alamat"
                                  value={this.state.addressForm}
                                  fullWidth
                                  onChange={(e) => this.setState({addressForm: e.target.value})}
                                />
                                
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid item xs={12}>
                                <TextField
                                  label="Catatan"
                                  value={this.state.remarkForm}
                                  fullWidth
                                  onChange={(e) => this.setState({remarkForm: e.target.value})}
                                />
                                
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                  label="Status"
                                  value={this.state.statusForm ? "Active":"Not Active"}
                                  fullWidth
                                  onChange={(e) => this.setState({statusForm: e.target.value})}
                                />
                                
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                  label="Koordinat Lokasi"
                                  multiline
                                  value={this.state.drawLocation}
                                  fullWidth
                                  onChange={(e) => this.setState({drawLocation: e.target.value})}
                                  disabled
                                />
                            </Grid>                            
                        </Grid>
                        <Grid item xs={12}>
                                <Button onClick={() => this.openMap()} variant="raised" color="primary" className="btn jr-btn-rounded btn-rounded btn-block">
                                    Lihat Peta
                                </Button>
                                <Dialog
                                  open={this.state.openMap}
                                  onClose={() => this.closeMap()}
                                  TransitionComponent={Transition}
                                  fullScreen
                                  >
                                      
                                      <br/>
                                      <br/>
                                      <br/>
                                          <Map 
                                            closeMap={(action, geojson, centroidLat, centroidLng) => this.closeMap(action, geojson, centroidLat, centroidLng)} 
                                            onUpdateCoords={this.setCoordsStr} 
                                            setCoordinates={(wktString, centroidLat, centroidLng) => this.setCoordinates(wktString, centroidLat, centroidLng)} 
                                            showDialog={this.showDialog} 
                                            drawnPolygon={(polygon)=>{this.drawnPolygon(polygon)}} 
                                            onDrawnPolygonChange={(drawnPolygon) => this.handleDrawnPolygonChange(drawnPolygon)} 
                                            idData={this.props.idData}
                                          />
                                  </Dialog>
                        </Grid>
                    </Grid>
                </div>
                </Dialog>

                
                    
               
            </div>
        );
    }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterGeofence/DialogForm.js